import { CalendarClock, CheckCircle, Clock, XCircle, AlertTriangle, type LucideIcon } from "lucide-react"

// Single source of truth for post/article status presentation. Previously defined 5×
// (IndustryNews, NapkinWisdom, RepurposingContent, PillarPosts, NewsPostsModal) with
// drifted labels ("Gepostet" vs "Veröffentlicht") and missing dark-mode variants.
export const statusConfig: Record<string, { label: string; color: string; icon: LucideIcon }> = {
  pending: {
    label: "Ausstehend",
    color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
    icon: Clock,
  },
  approved: {
    label: "Freigegeben",
    color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
    icon: CheckCircle,
  },
  rejected: {
    label: "Abgelehnt",
    color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
    icon: XCircle,
  },
  scheduled: {
    label: "Geplant",
    color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
    icon: CalendarClock,
  },
  posted: {
    label: "Veröffentlicht",
    color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
    icon: CheckCircle,
  },
  // A scheduled post whose time has passed but never published (e.g. an external-scheduler
  // failure). Surfaced by the Posting-Plan so the user can act on it.
  overdue: {
    label: "Überfällig",
    color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
    icon: AlertTriangle,
  },
}
